import GeneralFeedback from './GeneralFeedback'
import Loading from './Loading'

export { Loading }
export default GeneralFeedback
